// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*--------------------new design--------------------*/
  
/*--------------------/new design--------------------*/

.g2HWJRi3ZlsY26X7NjR9 {
  justify-content: space-between;
  background: transparent;
  gap: 10px;
  padding: 0;
  margin: 7px 0 7px 0;
  width: 100%;
}

.YL7SgdmW1uQPApLEASF3 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 10px;
  height: 40px;
  position: relative;
}

.YL7SgdmW1uQPApLEASF3::after {
  content: '';
  position: absolute;
  width: 100%;
  height: 1px;
  bottom: 0;
  right: 0;
  background: rgba(116, 116, 128, 0.4);
}


.YL7SgdmW1uQPApLEASF3 > p {
  font-size: 17px;
  line-height: 129%;
  letter-spacing: 0.43px;
  text-align: left;
}

.wbF3LHOkYhe5SDCWrLFh {
  position: relative;
  width: 100px;
  display: flex;
  align-items: center;
  height: 40px;
}

.wbF3LHOkYhe5SDCWrLFh img {
  position: absolute;
  border-radius: 50%;
  top: 0;
  left: 0;
  transition: z-index 0.3s ease 0s;
}

.wbF3LHOkYhe5SDCWrLFh img:nth-child(1) {
  z-index: 3;
}

.wbF3LHOkYhe5SDCWrLFh img:nth-child(2) {
  left: 15px;
  z-index: 2;
}

.wbF3LHOkYhe5SDCWrLFh img:nth-child(2):hover {
  z-index: 3;
} 

.wbF3LHOkYhe5SDCWrLFh img:nth-child(3) {
  left: 35px;
  z-index: 1;
}

.wbF3LHOkYhe5SDCWrLFh img:nth-child(3):hover {
  z-index: 4;
} 

@keyframes ZtQ6aYt8exfqKai1tgdb {
  0% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(0deg);
  }
}

.A5rIjOxHWNJb3SQfkrdA > svg {
  transform: rotate(180deg);
  transition: transform 0.3s ease;
}

.hSE7BDMGhQ1OKCWlxSYz > svg {
  animation: ZtQ6aYt8exfqKai1tgdb 0.3s ease;
}

/*--------------------new design--------------------*/

.WCdOqrzqy8BcH3DeHuAZ {
  padding: 16px;
  border-radius: 24px;
  background: rgba(var(--secondary-bg), 0.40);
  backdrop-filter: blur(40px);
  -webkit-backdrop-filter: blur(40px); 
  margin-bottom: 20px;
  transform: translateZ(0);
}

.VZsqb_hYDyaNzoH8dlti {
  position: relative;
  margin-bottom: 5px;
}

.ubi3rvbjSmrQ8VeItiNi {
  padding: 18px 18px 18px 50px;
  background: rgba(var(--tertiary-bg), 0.30);
  border-radius: 16px;
  height: 100%;
  width: 100%;
  border: none;
  outline: none;
  font-size: 15px;
  font-weight: 410;
  color: rgb(var(--placeholder-primary));
}

.ubi3rvbjSmrQ8VeItiNi::placeholder {
  color: rgb(var(--placeholder-primary));
}

.RXCctAGFQQKowSSuJbWY {
  position: absolute;
  top: 13px;
  left: 14px;
}

.cABJKgFmf3HVXhS53PEs {
  cursor: pointer;
  position: absolute;
  top: 17px;
  right: 14px;
  transition: fill 0.3s ease 0s;
}

.cABJKgFmf3HVXhS53PEs:hover > svg > path {
  fill: rgb(var(--placeholder-primary));
}

.nrlSNMTtPi9Jo4qGIRAA {
  text-align: center;
  margin-top: 10px;
  font-size: 21px;
}
  
/*--------------------/new design--------------------*/`, "",{"version":3,"sources":["webpack://./src/pages/main/assets/assets.module.css"],"names":[],"mappings":"AAAA,qDAAqD;;AAErD,sDAAsD;;AAEtD;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,SAAS;EACT,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,SAAS;EACT,QAAQ;EACR,oCAAoC;AACtC;;;AAGA;EACE,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,yCAAuC;AACzC;;AAEA,qDAAqD;;AAErD;EACE,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,0CAA0C;EAC1C,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,sDAAsD","sourcesContent":["/*--------------------new design--------------------*/\n  \n/*--------------------/new design--------------------*/\n\n.button {\n  justify-content: space-between;\n  background: transparent;\n  gap: 10px;\n  padding: 0;\n  margin: 7px 0 7px 0;\n  width: 100%;\n}\n\n.buttonBody {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  gap: 10px;\n  height: 40px;\n  position: relative;\n}\n\n.buttonBody::after {\n  content: '';\n  position: absolute;\n  width: 100%;\n  height: 1px;\n  bottom: 0;\n  right: 0;\n  background: rgba(116, 116, 128, 0.4);\n}\n\n\n.buttonBody > p {\n  font-size: 17px;\n  line-height: 129%;\n  letter-spacing: 0.43px;\n  text-align: left;\n}\n\n.buttonImgs {\n  position: relative;\n  width: 100px;\n  display: flex;\n  align-items: center;\n  height: 40px;\n}\n\n.buttonImgs img {\n  position: absolute;\n  border-radius: 50%;\n  top: 0;\n  left: 0;\n  transition: z-index 0.3s ease 0s;\n}\n\n.buttonImgs img:nth-child(1) {\n  z-index: 3;\n}\n\n.buttonImgs img:nth-child(2) {\n  left: 15px;\n  z-index: 2;\n}\n\n.buttonImgs img:nth-child(2):hover {\n  z-index: 3;\n} \n\n.buttonImgs img:nth-child(3) {\n  left: 35px;\n  z-index: 1;\n}\n\n.buttonImgs img:nth-child(3):hover {\n  z-index: 4;\n} \n\n@keyframes closeListAnimation {\n  0% {\n    transform: rotate(180deg);\n  }\n  100% {\n    transform: rotate(0deg);\n  }\n}\n\n.listOpen > svg {\n  transform: rotate(180deg);\n  transition: transform 0.3s ease;\n}\n\n.listClose > svg {\n  animation: closeListAnimation 0.3s ease;\n}\n\n/*--------------------new design--------------------*/\n\n.assets {\n  padding: 16px;\n  border-radius: 24px;\n  background: rgba(var(--secondary-bg), 0.40);\n  backdrop-filter: blur(40px);\n  -webkit-backdrop-filter: blur(40px); \n  margin-bottom: 20px;\n  transform: translateZ(0);\n}\n\n.assetsSearch {\n  position: relative;\n  margin-bottom: 5px;\n}\n\n.assetsSearchInput {\n  padding: 18px 18px 18px 50px;\n  background: rgba(var(--tertiary-bg), 0.30);\n  border-radius: 16px;\n  height: 100%;\n  width: 100%;\n  border: none;\n  outline: none;\n  font-size: 15px;\n  font-weight: 410;\n  color: rgb(var(--placeholder-primary));\n}\n\n.assetsSearchInput::placeholder {\n  color: rgb(var(--placeholder-primary));\n}\n\n.assetsSearchIcon {\n  position: absolute;\n  top: 13px;\n  left: 14px;\n}\n\n.assetsClearIcon {\n  cursor: pointer;\n  position: absolute;\n  top: 17px;\n  right: 14px;\n  transition: fill 0.3s ease 0s;\n}\n\n.assetsClearIcon:hover > svg > path {\n  fill: rgb(var(--placeholder-primary));\n}\n\n.notFound {\n  text-align: center;\n  margin-top: 10px;\n  font-size: 21px;\n}\n  \n/*--------------------/new design--------------------*/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `g2HWJRi3ZlsY26X7NjR9`,
	"buttonBody": `YL7SgdmW1uQPApLEASF3`,
	"buttonImgs": `wbF3LHOkYhe5SDCWrLFh`,
	"listOpen": `A5rIjOxHWNJb3SQfkrdA`,
	"listClose": `hSE7BDMGhQ1OKCWlxSYz`,
	"closeListAnimation": `ZtQ6aYt8exfqKai1tgdb`,
	"assets": `WCdOqrzqy8BcH3DeHuAZ`,
	"assetsSearch": `VZsqb_hYDyaNzoH8dlti`,
	"assetsSearchInput": `ubi3rvbjSmrQ8VeItiNi`,
	"assetsSearchIcon": `RXCctAGFQQKowSSuJbWY`,
	"assetsClearIcon": `cABJKgFmf3HVXhS53PEs`,
	"notFound": `nrlSNMTtPi9Jo4qGIRAA`
};
export default ___CSS_LOADER_EXPORT___;
